<template>
    <div class="">
        <Header/>

        <div class="login-container">
            <p class="welcome-text">Forgot your password?</p>

            <form class="login" @submit.prevent="login">
                <input type="text" v-model="email" placeholder="email">

                <b-alert
                    :show="dismissCountDown"
                    dismissible
                    :variant="alertClass"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                >
                    <p v-html="alertMessage"></p>
                    <b-progress
                        variant="warning"
                        :max="dismissSecs"
                        :value="dismissCountDown"
                        height="4px"
                    ></b-progress>
                </b-alert>

                <button type="submit" class="with-icon">Send</button>
            </form>
            <p class="register">Go back to <router-link to="/login">Login</router-link></p>
<!--            <p class="register">Don't have account? <a href="">Register here</a></p>-->


            <p class="login-links">
                <a href="">Help</a>
                <a href="https://dotag.com/" title="Dotag Website" target="_blank">dotag.fi</a>
                <a href="">Privacy policy</a>
            </p>
        </div>
    </div>
</template>

<script>
import Header from "@mobile/components/global/Header";

export default {
    name: 'FogotPassword',
    components: {Header},
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.$router.push('/');
        }
    },
    data() {
        return {
            email: '',
            password: '',
            alertMessage: '',
            dismissSecs: 5,
            dismissCountDown: 0,
            showDismissibleAlert: false,
            alertClass: 'danger'
        }
    },
    methods: {
        login: function () {
            let email = this.email;
            console.log('login');
            this.$store.dispatch('forgotPassword', email)
                .then((response) => {

                    if(response.status){
                        this.alertClass = 'success';
                        this.alertMessage = response.status;
                        this.showAlert();
                        this.email = null;
                    }
                    else if(response.errors){

                        this.alertClass = 'danger';
                        this.alertMessage = '';

                        for (const [key, value] of Object.entries(response.errors)) {
                            this.alertMessage = this.alertMessage + value + '<br />';
                        }
                        this.showAlert();
                    }
                })
                .catch(err => {
                    this.alertClass = 'danger';
                    console.log('err', err);
                    this.alertMessage = 'Invalid email';
                    this.showAlert();
                })
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-container {
    margin-top: 180px;
    width: 210px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 11px;
}

.login-container .welcome-text {
    margin-bottom: 20px;
}

.login-container input {
    margin-bottom: 8px;
}


.login-container button {
    background-image: url('~@images/red-circle.svg');
    border: 0;
    background-color: transparent;
    height: 67px;
    width: 67px;
    margin: 40px 0;
}

.login-container a {
    text-decoration: underline;
}

.login-container a:visited {
    color: #E10613;
}


.login-container .login-links {
    display: flex;
    justify-content: space-between;
}

.login-container .login-links {
    margin-top: 20px;
}
</style>
